module.exports = __webpack_public_path__ + "static/media/4.818d49d6.jpg";